module.exports = __webpack_public_path__ + "img/rsini_4.bc1f74cc.jpg";